import { useEffect, useState } from 'react';

// Hook to check if the user can hover
// @returns {boolean} canHover
const useCanHover = () => {
    const [canHover, setCanHover] = useState(false);

    useEffect(() => {
        const media = window.matchMedia('(hover: hover)');
        setCanHover(media.matches);

        // Add event listener to the media query
        const listener = () => setCanHover(media.matches);
        media.addEventListener('change', listener);

        // Clean up the event listener
        return () => media.removeEventListener('change', listener);
    }, []);

    return canHover;
};

export default useCanHover;